"use client";

import React from "react";
import ElectoralDistrictCard from "./electoralDistrictCard";
import { useElectoralDistrict } from "@/components/parts/admin/electoral-district/api";

const ElectoralDistrictSection = () => {
  const { data } = useElectoralDistrict("page=1&limit=1000");
  const electoralDisctrictData = data?.data.items;
  return (
    <section className="container py-7">
      <h3 className="text-center text-primary-700 font-semibold mb-7 text-xl md:text-3xl">
        Berikut Daftar Dapil DPRD PALI
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 place-items-center">
        {electoralDisctrictData?.map((item, index) => (
          <ElectoralDistrictCard key={index} id={item.id} title={item.name} />
        ))}
      </div>
    </section>
  );
};

export default ElectoralDistrictSection;
